import { finished } from 'stream'
import CaseCategory from '../models/CaseCategory'

// const baseUrl = 'http://amable.in:3111'
const baseUrl = 'http://74.208.25.43:3111'
export default {
  baseUrl,
  defaultProfileAvatarURL: `https://amable.s3.ap-south-1.amazonaws.com/uploads/user/user.png`,

  //also change value in NavigationLayout/index.css
  sidebarWidth: 200,

  // caseCategories: [new CaseCategory('1', 'Low TAT Investigation', 'LTI'), new CaseCategory('2', 'Detailed Investigation', 'DTI'), new CaseCategory('3', 'High Value Investigation', 'HVI')],

  caseStates: {
    initiated: 'initiated',
    generated: 'generated',
    open: 'open',
    report: "report",
    pushbackCA: "pushbackCA",
    pushbackRW: "pushbackRW",
    fold: 'fold',
    checked: 'checked',
    close: 'close',
    graded: 'graded',
    reinvestigate: 'reinvestigate',
    // mrdrequest:"mrd_request"
  },

  caseOutcome: {
    repudiation: 'Repudiation',
    genuine: 'Genuine',
    inconclusive: 'Inconclusive',
  },

  roleTitle: {
    admin: 'Admin',
    ceo: 'C.E.O.',
    md: 'M.D.',
    mis: "MIS",
    oh: 'Operations Head',
    tl: 'Team Lead',
    ca: 'Claim Analyst',
    investigator: 'Investigator',
    aa: 'Admin Assistant',
    ao: 'Admin Officer',
    zo: 'Zonal Head',
    rw: "Report Writer",
  },
  feedback: {
    insured: "Insured Feedback Analysis",
    hospital: "Hospital Feedback Analysis",
    pathologist: "Pathologist Feedback Analysis"
  },
  ClientType: {
    company: "Company",
    tpa: "Tpa",
  },
  UDI: {
    CaseCategory: {
      code: {
        LTI: 'LTI',
        DTI: 'DTI',
        HVI: 'HVI',
        DGV:"DGVI",
        SPLTI: "SPLTI"
      },
    },

    CaseType: {
      title: {
        Cashless: 'Cashless',
      },
    },
    Role: {
      title: {
        Investigator: 'Investigator',
        Claim_Analyst: 'Claim Analyst',
      },
    },
  },
  paymentStatus: {
    pending: 'pending',
    partial: 'partial',
    complete: 'complete',
  },
  treatmentType: {
    surgical: "Surgical",
    conservative: "Conservative"
  },
  diagnosis: {
    acqute: "Acqute",
    cronic: "Chronic"
  },
}